var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"video-contenar"}},[_c('video',{ref:"video_player",staticClass:"video-js vjs-default-skin vjs-16-9 vjs-big-play-centered"})])
}
var staticRenderFns = []

export { render, staticRenderFns }